import { createContext, useContext, useState } from "react";
import api from "../config/api";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

export const AdvisorContext = createContext();

export const AdvisorProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [topicLoading, setTopicLoading] = useState(false);
  const [advisorTopicLoading, setAdvisorTopicLoading] = useState(false);
  const [disLikeLoading, setDisLikeLoading] = useState(false);
  const [recommendationLoading, setRecommendationLoading] = useState(false);
  const [topicData, setTopicData] = useState(null);
  const [advisorData, setAdvisorData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [suggestedData, setSuggestedData] = useState([]);
  const [recommendationData, setRecommendationData] = useState([]);
  const [avaliableTimeSlotsData, setAvaliableTimeSlotsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [avaliableTime, setAvaliableTime] = useState([]);
  const [data, setData] = useState([]);
  const [appointmentPayload, setAppointmentPayload] = useState("");
  const [topicWordData, setTopicWordData] = useState([]);
  const [advisorTopicData, setAdvisorTopicData] = useState(null);
  const [advisorProfile, setAdvisorProfile] = useState(null);
  const [advisorProfileTopicImg, setAdvisorProfileTopicImg] = useState(null);
  const [appointmentData, setAppointmentData] = useState([]);
  const [userProfileData, setUserProfileData] = useState(null);
  const [topicRatings, setTopicRatings] = useState([]);
  const [topicRatingsLoading, setTopicRatingsLoading] = useState(false);

  const getTopAdvisorsList = async (request) => {
    setLoading(true);
    try {
      const response = await api.advisor.getTopAdvisorsList(request);
      if (response?.success) {
        setAdvisorData(response?.data);
        setLoading(false);
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const getTopicById = async (request) => {
    setTopicLoading(true);
    try {
      const response = await api.destination.getTopicById(request);
      if (response?.success) {
        const data = response.data;

        // ✅ Make sure media is always an array
        if (!Array.isArray(data.media)) {
          data.media = data.media ? [data.media] : [];
        }

        setTopicData(data);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setTopicLoading(false);
    }
  };

  const getTopicRatingById = async (request) => {
    setTopicRatingsLoading(true);
    try {
      const response = await api.destination.getTopicRatingById(request);
      if (response?.success) {
        setTopicRatings(response?.data || []);
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setTopicRatingsLoading(false);
    }
  };


  const globalSearch = async (request) => {
    setLoading(true);
    try {
      const response = await api.search.filterBy(request);
      if (response?.success && response?.data?.length > 0) {
        setFilterData(response.data);
        setTotalPages(response?.pagination?.totalPages);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const getRecommendation = async (request) => {
    setRecommendationLoading(true);
    try {
      const response = await api.recommendation.getMostRecommendation(request);
      if (response?.success) {
        setRecommendationData(response.data);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setRecommendationLoading(false);
    }
  };

  const getAvailableTimeSlot = async (request) => {
    setLoading(false);
    try {
      const response = await api.AvaliableTimeSlots.getAvailableSlots(request);
      if (response.success) {
        setAvaliableTimeSlotsData(response.data);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const checkAvaliableTimeSlot = async (request) => {
    // setLoading(true);
    try {
      const response = await api.findAvaliableTimeSlots.CheckAvaliableTimeSlots(
        request
      );
      if (response?.success && response?.data?.length > 0) {
        setLoading(false);
        setAvaliableTime(response.data);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const createAppointment = async (request) => {
    setLoading(true);
    try {
      const response = await api.AvaliableTimeSlots.createSlots(request);
      if (response?.success) {
        setLoading(false);
        toast.success(response?.message);
        setAppointmentData(localStorage.setItem("appointmentData", JSON.stringify(response?.data)));
      } else {
        setLoading(false);
        toast.error(response?.message);
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const updateAppointment = async (request) => {
    setLoading(true);
    try {
      const response = await api.AvaliableTimeSlots.updateSlots(request);
      if (response?.success) {
        setLoading(false);
        toast.success(response?.message);
      } else {
        setLoading(false);
        toast.error(response?.message);
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };


  const createOrder = async (request) => {
    setLoading(true);
    try {
      const response = await api.auth.createPaymentOrder(request);
      if (response?.success) {
        setLoading(false);
        setData(response?.data);
      } else {
        setLoading(false);
        setData([]);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!.");
    } finally {
      setLoading(false);
    }
  };

  const updateOrder = async (request) => {
    setLoading(true);
    try {
      const response = await api.auth.updatePaymentOrder(request);
      if (response?.success) {
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!.");
    } finally {
      setLoading(false);
    }
  };

  const topicLikeDislike = async (request) => {
    setDisLikeLoading(true);
    try {
      const response = await api.likeDislike.topicLikeDislike(request);
      if (response?.success) {
          setDisLikeLoading(false);
        toast.success(response?.message);
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "something went wrong!.");
    } finally {
      setDisLikeLoading(false);
    }
  };

  const getTopicDetailsById = async (request) => {
    setLoading(true);
    try {
      const response = await api.advisor.getTopicDetailsById(request);
      if (response?.success) {
        setTopicWordData(response?.data)
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "something went wrong!.");
    } finally {
      setLoading(false);
    }
  };

  const getSecureItineraryDetails = async (request) => {
    setLoading(true);
    try {
      const response = await api.advisor.getSecureItineraryDetails(request);
      if (response?.success) {
        setTopicWordData(response?.data);
      }
      return response;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || "something went wrong!.");
      return error?.response?.data || { success: false, message: error?.message };
    } finally {
      setLoading(false);
    }
  };

  const getAdvisorTopicByType = async (request) => {
    setAdvisorTopicLoading(true);
    try {
      const response = await api.advisor.getAdvisorTopicByType(request);
      if (response?.success) {
        setAdvisorTopicData(response?.data)
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "something went wrong!.");
    } finally {
      setAdvisorTopicLoading(false);
    }
  };

  const getAdvisorTopicBySearch = async (request) => {
    setAdvisorTopicLoading(true);
    try {
      const response = await api.advisor.getAdvisorTopicBySearch(request);
      if (response?.success) {
        setAdvisorTopicData(response?.data)
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "something went wrong!.");
    } finally {
      setAdvisorTopicLoading(false);
    }
  };

  const getAdvisorProfileById = async (request) => {
    setLoading(true);
    try {
      const response = await api.advisor.getAdvisorProfileById(request);
      if (response?.success) {
        setAdvisorProfile(response?.data)
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "something went wrong!.");
    } finally {
      setLoading(false);
    }
  };
  const getAdvisorProfileTopicImageById = async (request) => {
    setLoading(true);
    try {
      const response = await api.advisor.getAdvisorProfileTopicImageById(request);
      if (response?.success) {
        setAdvisorProfileTopicImg(response?.data)
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "something went wrong!.");
    } finally {
      setLoading(false);
    }
  };
  const getSearchSuggestions = async (request) => {
    setLoading(true);
    try {
      const response = await api.search.searchSuggestions(request);
      if ( response?.length > 0) {
        setSuggestedData(response);
      }
    } catch (error) {
      toast.error(error?.message || "something went wrong!.");
    }
    finally {
      setLoading(false);
    }
  }

  const getUserDataById = async (request) => {
    setLoading(true);
    try {
      const response = await api.advisor.getUserDetailById(request);
      if(response?.success) {
        setUserProfileData(response?.data)
      }
      return response;
    } catch (error) {
      toast.error(error?.message || "something went wrong!.");
    } finally {
      setLoading(false);
    }
  }

  const contextValue = {
    loading,
    topicLoading,
    recommendationLoading,
    disLikeLoading,
    topicData,
    totalPages,
    getTopAdvisorsList,
    getTopicById,
    setAdvisorData,
    advisorData,
    globalSearch,
    filterData,
    topicWordData,
    getRecommendation,
    recommendationData,
    getAvailableTimeSlot,
    avaliableTimeSlotsData,
    searchTerm,
    setSearchTerm,
    checkAvaliableTimeSlot,
    avaliableTime,
    createAppointment,
    updateOrder,
    createOrder,
    data,
    appointmentPayload, setAppointmentPayload,
    updateAppointment,
    topicLikeDislike,
    getTopicDetailsById,
    getSecureItineraryDetails,
    getAdvisorTopicByType,
    advisorProfile,
    advisorTopicData,
    advisorTopicLoading,
    getAdvisorProfileById,
    getAdvisorTopicBySearch,
    setAppointmentData,
    appointmentData,
    setAvaliableTime,
    advisorProfileTopicImg,
    getAdvisorProfileTopicImageById,
    suggestedData,
    setSuggestedData,
    getSearchSuggestions,
    getUserDataById,
    userProfileData,
    setUserProfileData,
    setTopicData,
    topicRatings,
    topicRatingsLoading,
    getTopicRatingById
  };
  return (
    <AdvisorContext.Provider value={contextValue}>
      {children}
    </AdvisorContext.Provider>
  );
};

AdvisorProvider.propTypes = {
  children: PropTypes.node,
};

export const useAdvisor = () => useContext(AdvisorContext);
